import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FilesCombobox from "Components/Files/FilesCombobox";
import InvoicesCombobox from "Components/Invoice/InvoicesCombobox";
import PriceField from "Components/UI/Form/PriceField";
import { InputAdornment } from "@mui/material";
export default function ClientInvoiceBundleFormGeneral({
  formData,
  files,
  invoices,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: "10px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Id"
            label="Id"
            value={formData.Id}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Amount"
            onChange={(newVal) => handleInputChange("Amount", newVal)}
            label="Belopp"
            value={formData.Amount}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {formData.CurrencyCode}
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="OCR"
            onChange={(e) => handleInputChange("OCR", e.target.value)}
            label="OCR"
            value={formData.OCR}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FilesCombobox
            label={"Fil"}
            files={files}
            selectedFileID={formData.FileId ? formData.FileId : null}
            onChange={(newVal) => handleInputChange("FileId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InvoicesCombobox
            label={"Faktura ID"}
            selectedInvoiceID={formData.InvoiceId ? formData.InvoiceId : null}
            onChange={(newVal) => handleInputChange("InvoiceId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Title"
            label="Klienttitel"
            value={formData.Title}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            // type="number"
            // InputProps={{
            //   readOnly: true,
            // }}
          />
        </Grid>
      </Grid>
    </>
  );
}
